import type { IconData } from '@stacksjs/iconify-core'

export const windowGrid: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M22 11H10V2H8v20h2v-9h12z\" opacity=\".25\"/><path fill=\"currentColor\" d=\"M3 2h5v20H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1\"/><path fill=\"currentColor\" d=\"M10 2h11a1 1 0 0 1 1 1v8H10zm0 11h12v8a1 1 0 0 1-1 1H10z\" opacity=\".5\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default windowGrid
